/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_BusyInputs */

const en_task_catalog_busy = /** @type {(inputs: Task_Catalog_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other activities of this case type were saved at the same moment. Try again.`)
};

const pt_br2_task_catalog_busy = /** @type {(inputs: Task_Catalog_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outras atividades deste tipo de caso foram salvas no mesmo instante. Tente novamente.`)
};

/**
* | output |
* | --- |
* | "Other activities of this case type were saved at the same moment. Try again." |
*
* @param {Task_Catalog_BusyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_busy = /** @type {((inputs?: Task_Catalog_BusyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_BusyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_busy(inputs)
	return pt_br2_task_catalog_busy(inputs)
});